<div>
  <div class="row justify-content-center">
    <div class="col-md-8">
      <div class="card mb-4">
        <div class="card-header py-3">
          @if (account) {
            <span class="font-18">
              Change Password for {{ account.login }}
            </span>
          }
        </div>
        <div class="card-body">
          @if (success) {
            <div class="alert alert-success">
              <strong>Password changed!</strong>
            </div>
          }
          @if (error) {
            <div class="alert alert-danger">
              <strong>An error has occurred!</strong> {{ error }}.
            </div>
          }

          @if (doNotMatch) {
            <div class="alert alert-danger">
              The password and its confirmation do not match!
            </div>
          }

          <form
            (ngSubmit)="changePassword()"
            [formGroup]="passwordForm"
            name="form"
            role="form"
          >
            <div class="mb-3">
              <label class="form-control-label" for="currentPassword"
                >Current password</label
              >
              <input
                class="form-control"
                formControlName="currentPassword"
                id="currentPassword"
                name="currentPassword"
                placeholder="Current password"
                type="password"
                autocomplete="off"
              />
              @if (
                passwordForm.get("currentPassword").invalid &&
                (passwordForm.get("currentPassword").dirty ||
                  passwordForm.get("currentPassword").touched)
              ) {
                <div>
                  @if (passwordForm.get("currentPassword").errors.required) {
                    <small class="form-text text-danger">
                      Your password is required.
                    </small>
                  }
                </div>
              }
            </div>
            <div class="mb-3">
              <label class="form-control-label" for="newPassword"
                >New password</label
              >
              <input
                class="form-control"
                formControlName="newPassword"
                id="newPassword"
                name="newPassword"
                placeholder="New password"
                type="password"
                autocomplete="off"
              />
              @if (
                passwordForm.get("newPassword").invalid &&
                (passwordForm.get("newPassword").dirty ||
                  passwordForm.get("newPassword").touched)
              ) {
                <div>
                  @if (passwordForm.get("newPassword").errors.required) {
                    <small class="form-text text-danger">
                      Your password is required.
                    </small>
                  }
                  @if (passwordForm.get("newPassword").errors.minlength) {
                    <small class="form-text text-danger">
                      Your password is required to be at least 8 characters.
                    </small>
                  }
                  @if (passwordForm.get("newPassword").errors.maxlength) {
                    <small class="form-text text-danger">
                      Your password cannot be longer than 50 characters.
                    </small>
                  }
                  @if (passwordForm.get("newPassword").errors.pattern) {
                    <small class="form-text text-danger">
                      Password Requirements:
                      <ul>
                        <li>Uppercase Letters</li>
                        <li>Lowercase Letters</li>
                        <li>Numbers</li>
                        <li>Special Characters: !&#64;#$%^&*()-_=+;:,.<>/?</li>
                      </ul>
                    </small>
                  }
                </div>
              }
              <jhi-password-strength-bar
                [passwordToCheck]="passwordForm.get('newPassword').value"
              ></jhi-password-strength-bar>
            </div>
            <div class="mb-3">
              <label class="form-control-label" for="confirmPassword"
                >New password confirmation</label
              >
              <input
                class="form-control"
                formControlName="confirmPassword"
                id="confirmPassword"
                name="confirmPassword"
                placeholder="Confirm the new password"
                type="password"
                autocomplete="off"
              />
              @if (
                passwordForm.get("confirmPassword").invalid &&
                (passwordForm.get("confirmPassword").dirty ||
                  passwordForm.get("confirmPassword").touched)
              ) {
                <div>
                  @if (passwordForm.get("confirmPassword").errors.required) {
                    <small class="form-text text-danger">
                      Your confirmation password is required.
                    </small>
                  }
                  @if (passwordForm.get("confirmPassword").errors.minlength) {
                    <small class="form-text text-danger">
                      Your confirmation password is required to be at least 8
                      characters.
                    </small>
                  }
                  @if (passwordForm.get("confirmPassword").errors.maxlength) {
                    <small class="form-text text-danger">
                      Your confirmation password cannot be longer than 50
                      characters.
                    </small>
                  }
                </div>
              }
            </div>
            <button
              [disabled]="passwordForm.invalid"
              class="btn btn-primary"
              type="submit"
            >
              Save
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
